import { Text } from "@simplybusiness/mobius";
import type { UseMutationResult } from "@tanstack/react-query";
import type {
  TradeOption,
  FetchTradesResult,
  TradeSelectionMeta,
} from "@simplybusiness/mobius-trade-selector";
import { LoadingState } from "./LoadingState";
import { TradesListState } from "./TradesListState";

export const TradesResults = ({
  mutation,
  variant,
  onTradeSelect,
}: {
  mutation: UseMutationResult<
    FetchTradesResult<TradeOption[]>,
    Error,
    string,
    unknown
  >;
  variant: "default" | "ai";
  onTradeSelect: (trade: TradeOption, meta: TradeSelectionMeta) => void;
}) => {
  // Only show results if we have data, an error, or are loading
  const shouldShowResults =
    mutation.data || mutation.isError || mutation.isPending;

  if (!shouldShowResults) {
    return null;
  }

  if (mutation.isPending) {
    return <LoadingState />;
  }

  if (mutation.isError) {
    return <Text variant="h4">Failed to fetch trades. Please try again.</Text>;
  }

  const trades = mutation.data?.results;
  const searchId = mutation.data?.searchId;

  if (!trades || trades.length === 0) {
    return (
      <Text variant="h4">No trades found. Try a different description.</Text>
    );
  }

  return (
    <TradesListState
      trades={trades}
      searchId={searchId}
      variant={variant}
      onTradeSelect={onTradeSelect}
    />
  );
};
